import { createQueryKeys } from "@lukemorales/query-key-factory"

export default createQueryKeys("jobs", {
  jobApplicationUsage: () => ({
    queryKey: ["job-application-usage"],
  }),
})
